import { fork, take } from "redux-saga/effects";

import actionTypes from "../actionTypes";


function* getRafflesUpdate(): any {
  /*const storeMission = yield select(getGameBoxMissionActualData);
  const raffleMission = !!storeMission && storeMission.filter((mission: { prize: { type: string; } }) => mission.prize?.type === 'raffleTicket');

  if (raffleMission.length) {
    try {
      const headers = {};
      const token = yield select(getToken);
      headers["x-access-token"] = JSON.stringify(token);
      const response = yield call(apiGet, 'REACT_APP_GAMEBOX_URL', apiRoutes.GET_ACTIVE_JACKPOTS, { token }, headers);
      const transformData = transformRaffleUpdateData(response?.data?.result?.raffles[0]);
      yield put(updateGameBoxRaffle(transformData));

    } catch (error) {
      console.log('getRafflesUpdate failure', error);
    }
  }*/
}

export default function* watchGameBoxRaffleUpdateRequest() {
  while (true) {
    yield take(actionTypes.GAME_BOX_JACKPOT_UPDATE_REQUEST);
    yield fork(getRafflesUpdate);
  }
};
